
import router from '@/router';

export default function auth({ to, next }) {
    const token = localStorage.getItem("auth_token");
    if (to.meta.requiresAuth && !token) {

        router.push("/");
        return;

    }

    if (to.path === "/" && token) {
        router.push("/admin-dashboard");
        return;

    }

    return next();
}
